import * as React from 'react'
import { ImageBase, Label, Link, PrimaryButton, Stack, TextField, Image, DefaultButton } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import '../../../css/components/login.scss';
import *  as Api from '../../../api/src';
import styled from 'styled-components';
import ErrorMesage from '../../../control/MessageBar/Error';
import { useHistory } from "react-router-dom";
import { commonfn } from '../../../common/commonfn';
import { ToastAppMsgContext } from '../../../context/toastApp.Context';
import { ToastAppType } from '../../../common/constant/enum/toastAppType';
const LoginStyle = styled.div`
height: 100%;
width: 100%;
display: flex;
align-items: center;
.login-stackItem{
    margin: auto;
}
}
.ms-md2{
    min-width:250px;
    margin-bottom: 12px;

}
.footer-page{
    text-align: center;
    position: fixed;
    bottom: 0;
    width: 100%;
    img{
        margin: 10px;
    }
}
`;
// Create an instance of PublicClientApplication
const UserApi = new Api.UserApi()
const ForgotPassword = () => {
    const { t } = useTranslation();
    let routerHistory = useHistory();
    const [email, SetEmail] = React.useState<string>("")
    const [emailErrorMessage, SetEmailErrorMessage] = React.useState('');
    const [forgotErrorMessage, SetForgotErrorMessage] = React.useState('');
    const [forgotSuccess, SetForgotSuccess] = React.useState(false);
    const { setToastData } = React.useContext(ToastAppMsgContext);
    const btnSubmit_click = async () => {
        if (!email) {
            SetEmailErrorMessage(t("IsRequired").replace("{0}", t("Email")));
            return;
        } else if (!commonfn.validateEmail(email)) {
            SetEmailErrorMessage(t("InvalidEmailAddress"));
            return;
        }
        let data = await UserApi.apiUserForgotPasswordPost(email);
        if (!data || data?.status != 200) return;
        if (data.data.Messages && data.data.Messages?.length > 0 && data.data.Messages[0] == "EmailNotExist") {
            SetForgotErrorMessage(t("EmailNotExist"));
            return;
        }
        SetForgotSuccess(true);
        setToastData({ Message: t("Successed"), Type: ToastAppType.Success });
    }
    const btnOk_click = async () => {
        routerHistory.push("/login")
    }

    return (
        <LoginStyle>
            {(!forgotSuccess) && (
                <Stack verticalAlign={'center'} className={"login-stackItem ms-Grid"} horizontalAlign={'center'}  >
                    <div className="ms-Grid-row  ms-Grid-col margin-0 ms-sm12 ms-md6">
                        <b> {t("ForgotPassword")}</b>
                    </div>
                    <div className="ms-Grid-row  ms-Grid-col margin-0 ms-sm12 ms-md6">
                        {t("EnterTheEmailAssociatedWithYourAccountAndWillSendAnEmailWithInstructionsToResetYourPassword")}
                    </div>
                    <div className="ms-Grid-row  ms-Grid-col margin-0 ms-sm12 ms-md6">
                        <ErrorMesage Message={forgotErrorMessage} onClose={() => { SetForgotErrorMessage('') }} />
                    </div>
                    <div className="ms-Grid-row ms-Grid-col ms-sm12 ms-md6">
                        <TextField errorMessage={emailErrorMessage} label={t('EmailAddress')} value={email} onChange={(e, value) => {
                            SetEmail(value || "");
                            SetEmailErrorMessage("");
                        }} />
                    </div>
                    <div className="ms-Grid-row ms-Grid-col ms-sm12 ms-md6">
                        <PrimaryButton text={t('Submit')} onClick={btnSubmit_click} />
                    </div>
                </Stack>
            ) || (
                    <Stack verticalAlign={'center'} className={"login-stackItem ms-Grid"} horizontalAlign={'center'}  >
                        <div className="ms-Grid-row  ms-Grid-col margin-0 ms-sm12 ms-md6">
                            <b> {t("CheckYourEmail")}</b>
                        </div>
                        <div className="ms-Grid-row  ms-Grid-col margin-0 ms-sm12 ms-md6">
                            {t("CheckYourEmailWeHaveSentAPasswordRecoveryInstructionToYourEmail")}
                        </div>
                        <div className="ms-Grid-row  ms-Grid-col margin-0 ms-sm12 ms-md6">
                            {t("CheckYourEmailWeHaveSentAPassword")}
                        </div>
                        <div className="ms-Grid-row ms-Grid-col ms-sm12 ms-md6">
                            <PrimaryButton text={t('Ok')} onClick={btnOk_click} />
                        </div>
                    </Stack>
                )}
            <div className={"footer-page"}>
                <img style={{ height: 30 }} src='/images/logo.png'></img>
            </div>
        </LoginStyle>
    );
}
export default ForgotPassword;